/*
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-06-23 08:29:24
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-06-25 14:46:50
 * @FilePath: \vysa_wifi_web\src\utils\index.ts
 * @Description: 公共方法
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import wx from "weixin-js-sdk-ts";
import { postWxconfigData } from '@/api'
import store from '@/store'
import { showToast } from "vant";

export function setWxConfig (jsApiList: any, openTagList: any = []) {
  const data = {
    appId: store.state.appId || sessionStorage.getItem('appId'),
    url: window.location.href
  }
  postWxconfigData(data).then((res: any) => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。  
      appId: res.result.appId, // 必填，公众号的唯一标识，填自己的！  
      timestamp: res.result.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据  
      nonceStr: res.result.nonceStr, // 必填，生成签名的随机串  
      signature: res.result.signature, // 必填，签名  
      jsApiList,  
      openTagList
    })
    wx.ready(() => {
      console.log("微信配置成功");
    });
    wx.error((err: any) => {
      showToast({ message: JSON.stringify(err) });
    });
  })
}